import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
let a = {
    ...zhLocale,
    selectLanguage: '选择语言',
    chinese: '中文',
    english: '英文',
    logout: '退出登录',
    netError: '网络连接错误，请稍后重试',
    cancel:'取消',
    confirm:'确定',
    delete:'删除',
    save:'保存',
    recovery: '恢复',
    rename:'重命名',
    userSpace: '个人空间',
    entSpace: '企业空间',
    allUser: '所有用户',
    frozen: '已冻结',
    upload: '上传',
    import: '导入',
    tips: '提示',
    prompt: '提示',
    success: '成功',
    return: '返回',
    edit:'编辑',
    close: '关闭',
    noSearch: '搜索无结果',
    loadmore: '加载更多',
    retry: '重试',
    allDelete: '全部删除',
    nextStep:'下一步',
    nodata:'没有相关的查询结果',
    back: '上一步',
    gotIt:'知道了',
    ad: 'AD',
    corpWX: '企业微信',
    dingding: '钉钉',
    weaverOA:'泛微OA',
    weaver:'泛微',
    LDAP: 'LDAP',
    ADFS: 'ADFS',
    kingdee: '金蝶云',
    moduleType: '模块类型',
    serviceType: '服务类型',
    search: '查询',
    discription:'描述',
    creater: '创建者',
    createTime: '创建时间',
    version: '版本号',
    status: '状态',
    operation: '操作',
    read: '查看',
    start: '启动',
    stop: '停止',
    data: '数据结构',
    create: '新建',
    runing: '运行',
    toDelete: '确认删除',
    more: '更多',
    batchStart: '批量启动',
    batchStop: '批量停止',
    batchDelete: '批量删除',
    message:{
        addSuccess:'添加成功',
        deleteSuccess:'删除成功',
        dismissSuccess:'解散成功',
        setSuccess:'设置成功',
        setFailed:'设置失败',
    },
    valid: { //校验
        noSpace: '空间大小不能为空',
        intSpace: '空间大小请输入正整数',
        moreSpace: '不能超过企业总空间大小',
        moreData: '不能超过数据中心容量',
        noPwd: '密码不能为空',
        limitWord: '长度为6-32个字符之间',
        manyWord: '6-32个字符，必须包含字母、数字、符号中的两种',
        phone: '请输入正确的手机号',
        noMail: '请输入登录邮箱',
        errorMail: '请输入正确的邮箱格式',
        noName: '请输入姓名',
    },
    log: {
        userSpace: '个人空间',
        entSpace: '企业空间',
        time: '时间',
        actionName: '动作',
        netError: '网络连接错误，请稍后重试',
        title: '日志查询',
        datearea: '时间',
        dateareaTip: '为了查询效率,每次限查询31天日志',
        dateTo: '至',
        dateStart: '开始日期',
        dateEnd: '结束日期',
        logExport: '导出日志',
        category: '操作的类型',
        allCategory: '全部',
        action: '动作',
        allAction: '全部动作',
        space: '空间',
        allSpace: '全部空间',
        pathValue: '路径关键词',
        pathValuePH: '请输入路径关键词',
        operator: '操作者',
        operatorPH: '按操作者查询',
        optionOther: '附加筛选条件',
        search: '查询',
        reset: '重置',
        object: '对象',
        detail: '详情',
        ip: 'IP地址',
        device: '设备',
        logNull: '没有找到相关日志',
        logNull2: '请修改查询条件后重试',
        userSearchNot: '没有搜索到该操作者',
        userStrSize: '操作者最多可输入50个字符',
        fileName: '文件',
        folderName: '文件夹',
        freeze:'冻结',
        team: '团队',
        select:'选中',
        item:'项',
        nullData:'无'
    },
    logTimingExport:{
        delete:'删除',
        title:'日志定时导出',
        headInfo:'每个月月初定时导出上个自然月的日志文件。日志文件保留{year}年，请及时下载。',
        noLog:'还没有生成日志',
        openTimingExport:'已开启定时导出日志',
        closeTimingExport:'定时导出已关闭',
        comfirmDelete:'您确定要删除选中的日志文件吗？',
        deleteSuccess:'日志删除成功',
        deleteLog:'删除日志',
        fileName:'文件名',
        creatTime:'生成时间',
        operation:'操作',
        download:'下载',
        batchDownload:'批量下载',
        logExportLanguage:'导出日志语言',
        logExportLanguageTips:'语言切换成功,下次导出时生效'
    },
    fileTemp:{
        all:'全部',
        edit:'编辑',
        operate:'操作',
        topword:'Top',
        fileTemptitle:'文件模板',
        fileTempType:'模板类型',
        newFileTempType:'新建模板类型',
        searchPlaceholder:'搜索模板关键词',
        typeManage:'类型管理',
        addTemp:'添加模板',
        editTemp:' 编辑模板',
        defaultType:'默认类型',
        tempTypeName:'模板名称',
        DC:'所属数据中心',
        tempTeam:'适用团队',
        state:'状态',
        pbliushT:'已发布',
        pbliushF:'未发布',
        publish:'发布',
        repeal:'撤销',
        deleteTemp:'删除模版',
        more:'更多',
        top:'置顶',
        cancelTop:'取消置顶',
        deleteTempTips:'确认要删除当前模板吗？',
        allTeam:'全部团队',
        typeName:'类型名称',
        typeNamePlaceholder:'请输入类型名称',
        tempTypeMaxNum:'模板类型数量已达上限，无法继续创建',
        tempMaxNum:'模板数量已达上限，无法继续创建',
        notNull:'不能为空或空格',
        strReg:'不能包含以下字符/\\:*?\'<>|',
        max10:'最多输入10个字',
        tempPlaceHolder:'请输入模板名称',
        tempTypePlaceHolder:'请选择模板类型',
        teamPlaceHolder:'请选择团队',
        selectFile:'选择文件',
        amend:'修改',
        selectFromPan:'选择网盘文件',
        teamNotNull:'还没有添加任何团队',
        fileNotNull:'请选择文件',
        sizeReg:'文件大小不能超过50M',
        viriusFile:'该文件包含病毒，不可使用',
        tempTypeManage:'模板类型管理',
        addType:'添加类型',
        deleteTitle:'删除模版类型',
        deleteTypeTips1:'即将删除的模版类型存在模版文件,',
        deleteTypeTips2:'请选择模版文件的处理方式',
        deleteTypeTips3:'只删除模版类型，模版文件将移动到默认类型中',
        allDelete:'一并删除',
        onlyTypeDelete:'仅删除类型',
        publishSuccess:'发布成功',
        topSuccess:'置顶成功',
        cancelTopSuccess:'取消置顶成功',
        repealSuccess:'撤销成功',
        saveSuccess:'保存成功',
        searchNull:'没有搜索到～',
        listNull:'文件模板列表为空'
    },
    offline: {
        cancel: '取消',
        confirm: '确定',
        confirmTitle: '提示',
        masterSwitchTitle: '离线文档管控',
        encryptModeTitle: '密钥模式：',
        encryptEntMode: '企业加解密',
        encryptEntModeTip: '下载的加密文件企业内的成员都可以解密',
        encryptAccountMode: '账户加解密',
        encryptAccountModeTip: '下载的加密文件仅下载者可以解密',
        LinkModeTitle: '文档管控规则：',
        approvalLinkMode: '创建链接需审批',
        banLinkMode: '禁止链接',
        switchEncryptTip: '切换秘钥模式会导致之前下载的文件无法解密，请确认是否继续？',
        submit: '提交',
        submitSuccess: '提交成功',
        hotLine: '联系客服开通服务，请拨打：400-898-7968',
        offlineTip: '网络问题，请重新尝试提交',
        selectedSummary: '共{personNum}个成员，{teamNum}个团队',
        selectedSummaryEnt: '共{personNum}个成员，{teamNum}个团队，{orgNum}个组织',
        controlUser: '添加管控成员',
        directory: '共{0}个目录',
        belongTeam: '等{0}个团队',
        copymove: '管控目录的文件',
        linkApprover: '链接审批者',
        linkApproverInput: '输入用户名或邮箱，最多可设置5个审批者',
        linkApproverTips: '如果未指定审批者，则遵循{str}',
        linkApproverTipsInsert: '默认审批者逻辑',
        approverDialogTitle: '默认审批者逻辑',
        readyApproverTips: '未指定审批者，遵循默认审批者逻辑',
        approverLogic1:'1.普通成员创建外链，默认审批者为该文件的最近的{admin}。',
        approverLogic2:'2.如果创建外链者是该外链文件的{admin}，则默认审批者为最近的上级{admin}。',
        approverLogic3:'3.创建外链的文件无{admin}，默认审批者为网盘管理员。',
        approverLogic4:'最近的定义：逐级递归向上找上一级的{admin}，直至网盘管理员。',
        notes:'注：',
        approverDocAdmin: '文档管理员',
        approverTeamAdmin: '团队管理员',
        forbiddenCopymove:'禁止移动/复制',
        forbiddenCopymoveTip:'勾选禁止移动/复制后，通过客户端下载的管控文件只能通过客户端回传到原目录',
        forbiddenCopymove1: '您确定要取消“禁止移动/复制”选项吗？',
        forbiddenCopymove2: '取消后有权限的用户可能将该目录内文件移动/复制到其他目录跳过指定审批',
        copymoveTip: '管控目录内的文件以及所有上级目录均受到限制（管控目录内的文件路径，所有层级均受到限制）',
        maxWhite: '白名单成员不能超过{0}人',
        maxDir: '白名单目录不能超过{0}条',
        defaultApprovers: '默认审批者',
        etc:'{name}等{num}人',
        approvalRule:'受管控对象从企业空间发送外链时，除以下审批规则外都遵从{rule}进行审批，防止文件泄露'
    },
    memberControl: {
        frozon: '已冻结',
        noTeamSearch: '没有相应的团队和成员',
        noUserSearch: '没有相应的成员',
        existTip: '不能重复选择同一个人或者团队',
        existToast: '不能重复选择同一个人',
        maxLenTip: '添加失败，团队或成员超出上限',
        controlList: '受管控成员 ：',
        whiteList: '管控白名单',
        partMember: '部分团队/成员',
        partMemberEnt: '部分团队/组织/成员',
        allMember: '所有成员',
        noControlList: '还未添加管控成员/团队',
        noControlListEnt: '还未添加管控成员/团队/组织',
        noWhiteList: '还未添加管控白名单成员',
        selectedSummary: '已管控{teamNum}个团队，{personNum}个成员',
        selectedSummaryEnt: '已管控{teamNum}个团队，{orgNum}个组织，{personNum}个成员',
        selectedMemberSummary: '已选{personNum}个成员',
        searchPlaceholder: '搜索团队名、用户名或邮箱',
        searchMemberPlaceholder: '搜索用户名或邮箱',
        dialogTitle: '选择团队/成员',
        dialogVerSelectedMemberSummary: '已加入白名单({personNum})'
    },
    controlDictionary: {
        noResult: '搜索无结果',
        title: '请搜索或选择团队/成员',
        searchPlaceholder: '搜索用户名、邮箱或团队名',
        searchOrgTeam: '搜索用户名、邮箱或组织名',
        selectedSummary: '已选择{teamNum}个团队，{personNum}个成员',
        selectedSummaryEnt: '已选择{teamNum}个团队，{orgNum}个组织，{personNum}个成员',
        noMemberAdded: '请选择团队/成员加入',
        noMemberEnt: '请选择团队/组织/成员加入',
        selectAll: '全选',
        searchSelectedSummary: '已选中 {n}项',
        addButton: '添加',
        category: '类别：',
        teamUser: '团队和成员',
        orgUser: '组织和成员',
    },
    edas: {
        delConfirm: '是否确认删除',
        ad: 'AD',
        baseDN: 'Base DN',
        corpId: 'corpid',
        appId: 'appId',
        corpSecret: 'corpSecret',
        ProviderSecret: 'ProviderSecret',
        secret: 'secret',
        appKey: 'appKey',
        appSecret: 'appSecret',
        appKeySecret: 'appKeySecret',
        URL:'URL',
        LDAP: 'LDAP',
        ADFS: 'ADFS',
        authentication: '企业认证服务配置',
        callBackUrl: 'CallbackURL',
        agentId: 'agentId',
        status: '状态',
        operation: '操作',
        cancel: '取消',
        confirm: '确定',
        next: '下一步',
        last: '上一步',
        delete: '删除',
        tips: '提示',

        departmentID: '部门标识字段',
        departmentName: '部门名称字段',
        parentDepartment:'父部门',
        agentTips:'当前服务类型无需选择代理名称',
        // syncMode: '同步方式',
        // syncOrganization: '同步到组织',
        // syncTeam: '同步到团队',
        // syncUserOnly: '仅同步用户',
        // syncOrganizationToolTip: '将对接系统的组织和人员同步到网盘组织中',
        // syncTeamToolTip: '将对接系统的人员同步到组织下，将对接系统的组织结构同步到团队中',
        // syncUserOnlyToolTip: '仅将对接系统的人员同步到组织根节点下，不同步组织',
        hours: '时',
        mins: '分',
        more: '更多',
        back: '返回',
        detail: '详情',
        object: '对象',
        action: '动作',
        remarks: '备注',
        success: '成功',
        team: '团队',
        move: '移动',
        frozen: '冻结',
        netError: '网络连接错误，请稍后重试',
        setFilter: '设置过滤条件',
        import: '导入',
        modify: '修改',
        upload: '上传',
        edit: '编辑',
        condition: '个条件',
        loadMore: '加载更多',
        items: '项',
        // organization:'组织',
        // unSyncOrganization:'未同步组织',
        urlTip:'请输入带http://或https://的URL',
        title: '企业账户认证',
        subHeader: '您可以将开放平台与企业域对接，快速导入及同步企业已有用户和组织架构。',
        importServerConfig: '组织导入服务配置',
        sync: '组织导入服务配置',
        authServerConfig: '登录认证服务配置',
        auth: '登录认证服务配置',
        agentName: '代理名称',
        serviceName: '服务名称',
        serial: '序列号',
        ctime: '创建时间',
        addAgentServer: '添加代理服务',
        addServerConfig: '添加服务配置',
        editServerConfig: '编辑服务配置',
        autoSyncTime: '自动同步时间',
        lastSyncTime: '上次同步时间',
        newAgentSrver: '新建代理服务',
        unbound: '解除绑定',
        unbind: '未绑定',
        normal: '正常',
        disconnect: '断开',
        hasAddAgentServer: '代理服务已添加',
        unboundTips: '解除绑定后，该代理服务不可用，是否继续解除？',
        confirmUnbound: '继续解除',
        deleteTips: '删除后，该服务将解绑并清除相关参数，是否继续？',
        serviceType: '服务类型',
        corpWX: '企业微信',
        dingding: '钉钉',
        weaver:'泛微',
        weaverOA:'泛微OA',
        customize: '自定义',
        none: '无',
        submit: '提交',
        connectConfig: '连接配置',
        serviceAddress: '服务器地址',
        serviceManageAccount: '服务器管理账号',
        password: '密码',
        port: '端口',
        fieldMapping: '字段映射',
        userID: '用户标识字段',
        userNameField: '用户名称字段',
        emailField: '用户邮箱字段',
        mobileField: '用户手机字段',
        login: '用户登录字段',
        teamID: '团队标识字段',
        teamName: '团队名称字段',
        allowMailImportToBeEmpty: '邮箱导入允许为空',
        mailImportToolTip: '如果去掉勾选,即不允许为空,则邮箱为空的用户不导入',
        customField: '自定义字段',
        lenovoboxField: '网盘字段',
        importField: '导入字段',
        addField: '添加字段',
        syncConfig: '同步配置',
        defaultImportMode: '默认导入方式',
        allImport: '全部导入',
        allNoImport: '全部不导入',
        syncMode: '同步方式',
        syncOrganization: '同步到组织',
        syncTeam: '同步到团队',
        syncUserOnly: '仅同步用户',
        syncOrganizationToolTip: '将对接系统的组织和人员同步到网盘组织中',
        syncTeamToolTip: '将对接系统的人员同步到组织下，将对接系统的组织结构同步到团队中',
        syncTeamToolTipNotEnterPrise: '将对接系统的组织结构同步到团队中',
        syncUserOnlyToolTip: '仅将对接系统的人员同步到组织根节点下，不同步组织',
        syncUserOnlyToolTipNotEnterPrise: '仅将对接系统的人员同步到团队根节点下，不同步组织',
        syncTime: '同步执行时间',
        accordingDay: '按天',
        accordingHour: '按时',
        hour: '时',
        min: '分',
        adfsCertificate: 'adfs证书 (jks格式)',
        certificatePassword: '证书密码',
        adfsAddress: 'ADFS地址',
        everyday: '每天',
        every: '每',
        syncOperation: '立即同步',
        log: '日志',
        setServiceConfig: '设置服务配置',
        setFiltrationConditions: '设置过滤条件',
        deleteSuccess: '已删除成功',
        syncCompleteTime: '同步完成时间',
        syncSuccess: '同步成功',
        syncFail: '同步失败',
        unSync: '未同步',
        unSyncToolTip: '通过黑名单过滤未同步的数据',
        export: '导出',
        syncDetail: '同步详情',
        detailSyncTime: '同步时间',
        allSyncResult: '全部同步结果',
        failReasons: '失败原因',
        fail: '失败',
        user: '用户',
        created: '创建',
        update: '更新',
        unfrozen: '解冻',
        filter: '已过滤',
        unSyncUser: '未同步用户',
        unSyncTeam: '未同步团队',
        importServiceConfigCuccess: '添加导入服务配置成功！',
        filterInquiry: '是否立即去设置导入过滤条件？',
        noSettings: '暂不设置',
        goSettings: '前往设置',
        addFilter: '添加条件',
        addFilterCondition: '添加过滤条件',
        modifyFilterCondition: '修改过滤条件',
        batchImport: '批量导入',
        userEmail: '用户邮箱',
        userPhone: '用户手机',
        userName: '用户名称',
        teamUser: '团队名称',
        filteringContent: '过滤内容',
        allConditionalType: '全部条件类型',
        allFilterMode: '全部过滤方式',
        noImport: '不导入',
        conditionalType: '条件类型',
        filterMode: '过滤方式',
        importModeDesc: '导入方式可在服务配置中修改',
        addedNumber: '已添加',
        addedText: '个条件',
        first: '第一步',
        downloadTemp: '下载模板',
        downloadTempDesc: 'xls或xlsx文件',
        second: '第二步',
        editedUpload: '编辑内容后，上传',
        uploadCertificate: '上传证书',
        deleteItem: '删除选中项',
        selectedText: '确定删除选中的',
        importLogTitle: '导入配置的日志列表',
        mostNumber: '最多10条字段',
        enterLenovoboxField: '请输入网盘字段',
        enterImportField: '请输入导入字段',
        agentRelease: '代理绑定已解除',
        noServiceConfig: '未添加服务配置',
        noAgentService: '未添加代理服务',
        syncConfigDesc: '提交后，可添加过滤条件筛选部分用户',
        noDetailResulr: '没有相应的搜索结果',
        filterTitleTip: '默认导入全部数据，可设置全部不导入，通过添加条件来导入部分数据',
        importAcount: '总计导入',
        copy: '复制',
        copySuccess: '复制成功',
        copyFail: '复制失败',
        serviceNamePlaceholder: '请输入服务配置名称，最多50个字符',
        serviceAddressPlaceholder: '例如：120.22.100.11',
        manageAccountPlaceholder: '请输入将要连接的服务器管理账号',
        enterPasswordPlaceholder: '请输入密码',
        verificationRequired: '请输入验证码',
        verificationTip: '看不清请点击',
        enterSearchValue: '请输入搜索内容',
        selectFilterType: '请选择过滤条件类型',
        enterEmail: '请输入用户邮箱',
        enterUserPhone: '请输入用户手机',
        enterUserName: '请输入用户名称',
        enterTeamName: '请输入团队名称',
        noSearchResult: '请输入团队名称请换个关键词再试试',
        beyondLimit: '超出10000条上限',
        configSuccess: '配置成功',
        deleteConfirm: '确认删除？',
        item: '个',
        noFilterSearchResult: '无相应的搜索结果，请换个关键词再试试',
        character: '请输入服务配置名称，最多50字符',
        noErrorSpecialCharacters: '不允许输入以下下特殊字符"\\/:*?\'\<\>|"',
        isSyncing: '执行同步中',
        jksFile: 'jks格式',
        uploadJksFile: '请上传jks格式文件',
        inputCertificatePassword: '请输入证书密码',
        address: '请输入地址',
        modifySuuccess: '修改成功',
        agentPlaceholder: '请输入代理服务名称，最多50个字符',
        inputTeamOrUser: '输入用户名/团队名搜索',
        addFilterSuccess: '添加过滤条件成功',
        modifyFilterSuccess: '修改过滤条件成功',
        errorEmail: '邮箱格式不正确',
        errorMobile: '手机格式不正确',
        bindingServerConfig: '第三方绑定服务配置',
        matchingRule: '匹配规则',
        mobile: '手机号',
        email: '邮箱',
        syncResult: '同步结果',
        newBinding: '新绑定',
        failBinding: '绑定失败',
        account: '账号',
        bindingLogTitle: '绑定配置的日志列表',
        inputAccount: '请输入账号',
        organization:'组织',
        unSyncOrganization:'未同步组织',
        mostCustomNumber: '最多{0}条字段',
        createAgentFirst: '请先配置代理服务',
        hasNoAgentNow: '暂无代理服务',
        notNeedAgent: '当前服务类型无需选择代理名称',
        connectFieldName: '连接配置项名称',
        connectFieldContent: '连接配置项内容',
        enterConnectFieldName: '请输入连接配置项名称',
        enterConnectFieldContent: '请输入连接配置项内容',
        SSO: '单点登录（SSO）服务配置',
        sso: '单点登录（SSO）服务配置',
        identification: '匹配标识',
        signCongit: '扫码登录服务配置',
        sign: '扫码登录服务配置',
        scanName: '登录名',
        boxUrl: '网盘访问地址',
        copyUrl: '复制地址',
        ssoWarning: '由于您使用了代理服务，系统无法获取到代理服务器地址，因此请您在使用网盘访问地址时，需手动将代理服务的IP或地址填写在xxx位置，例如：https://lenovows.com/user/manage',
        agentWarning: '代理服务最多添加1个配置',
        importWarning: '组织导入服务最多添加1个配置',
        authWarning: '登录认证服务最多添加1个配置',
        schema: 'schema',
        userStatus: '用户状态',
        probation:'试用',
        formal:'正式',
        temporary:'临时',
        probationExtension:'试用延期',
        dismissal:'解聘',
        resignation:'离职',
        retirement:'退休',
        invalid:'无效,只同步正式用户',
        importSealTeam:'导入封存团队',
        yes:'是',
        no:'否',
        relationship: '关系',
        appIdMobile: 'appIdMobile',
        appSecretMobile: 'appSecretMobile',
        applicationVoucher:'应用凭证',
        applicationVoucherTitle:'配置连接钉钉的应用凭证，用于获取钉钉用户的基础信息',
        scanLogin:'扫码登录',
        qrcode:'扫码登录',
        scanLoginTitle:'配置钉钉扫码登录应用授权信息，以实现钉钉扫码登录网盘',
        mobileAuthorizedLogin:'移动端授权登录',
        mobileAuthorizedLoginTitle:'配置钉钉“移动应用接入-分享”授权信息，以实现移动端可以通过钉钉授权登录',
        kingdee: '金蝶云',
        createSuperiorTeam: '自动创建上级团队',
        createSuperiorOrg: '自动创建上级组织',
        autCreateSuperiorTeam: '添加的过滤条件同步到团队时自动创建上级团队',
        autCreateSuperiorOrg: '添加的过滤条件同步到组织时自动创建上级组织',
        all: '选择全部',
        serviceList: '服务列表',
        searchSuccess: '查询成功',
        uploadError: '上传失败',
        confirmClose: '确认关闭？',
        confirmOperation: '确认批量处理么？',
        loading: '请稍等...',
        allSuccess:'批量操作成功',
        startSuccess:'启动成功',
        closeSuccess:'关闭成功',
        uploadSuccess:'上传成功',
    },
    addUser: {
        title: '添加成员',
        searchLable: '请搜索或选择成员：',
        searchInput: '搜索用户名、邮箱或组织名',
        allSelected: '共{0}个成员',
        selected: '已选择{0}个成员',
        selectJoin: '请选择成员加入',
        continue: '添加现有成员，将变更用户的组织关系, 是否继续?',
    },
    batchImport: {
        bulk: '批量导入用户',
        title: '批量添加用户',
        downloadTemp: '第一步：下载模版文件',
        editTemp: '第二步：编辑模版文件',
        uploadTemp: '第三步：上传编辑好的文件',
        downloadBtn: '下载模版',
        fileType: 'xls或xlsx文件',
        progress: '正在导入模板中的用户，请稍后...',
        total: '总计{0}个用户',
        upSuccess: '成功导入{0}个用户',
        upFailed: '{0}个账户导入失败',
        user: '用户名',
        mail: '登录邮箱',
        phone: '手机号码',
        pwd: '密码',
        org: '组织',
        state: '状态',
        noFile: '还没有上传文件',
        errorType: '不能上传{0}，文件类型不允许',
        emptyFile: '文件为空',
        upSuccessTip: '导入成功',
        more: '文件超过500M了，请使用',
        client: '客户端',
        upload: '上传',
        flashTip: '要使用该功能，您需要安装Flash插件, 猛击',
        here: '这里',
        install: '安装',
        force: '强制导入的用户修改初始密码'
    },
    createUser: {
        title: '添加用户',
        org: '所属组织：',
        mail: '登录邮箱：',
        mailInput: '请输入登录邮箱',
        name: '姓名：',
        nameInput: '请输入姓名',
        phone: '手机号：',
        date: '有效期：',
        setDate: '添加账户有效期',
        seletDate: '选择日期',
        data: '数据中心：',
        space: '个人空间：',
        spaceInput: '请输入空间大小',
        spaceTips: '不能超过总空间大小',
        active: '通过电子邮件发送激活链接，由用户自行设置密码',
        set: '由管理员设置密码',
        pwdTips: '密码6-32个字符，至少两种字符组合',
        forbidPwd: '禁止账户修改密码',
        allowPwd: '允许修改密码',
        firstLoginPwd: '首次登录修改密码',
        success: '创建用户成功',
        phonePlaceholder: '请输入手机号码',
        area:'搜索国家/地区',
        areaNull: '未找到相关国家或地区',
        seletDateTips: '超过此日期，该账户将无法登陆'
    },
    userSet: {
        title: '用户设置',
        userType: '用户类型：',
        sended: '已发送',
        active: '已激活',
        noactive: '未激活',
        sendEmail: '激活邀请',
        pwd: '登录密码：',
        setPwd: '修改登录密码',
        inputPwd: '请输入密码',
        team: '所属团队：',
        invitation: '邀请发送成功',
        invitationSuccess: '1小时内不可重复发送激活邀请',
        success: '用户设置成功',
        noData: '该用户个人空间已存有数据，无法更换数据中心？',
        confirmData: '如需更换，可迁移数据后重试',
        isData: '是否确定更换数据中心？',
        yesData: '更换数据中心后，已删除的数据不可恢复',
        localUser: '本地认证用户',
        entUser: '企业认证用户',
        thirdUser: '第三方认证用户',
        pwdTip:'第三方应用同步的用户不支持设置密码'
    },
    adminRole:{
        title: '管理员角色'
    },
    orgManage:{
        title: '组织管理',
        createUser:'创建新用户',
        addLocalUser:'添加现有用户',
        batchUser:'批量导入用户',
        forze:'冻结',
        unforze:'解除冻结',
        batchSet:'批量设置',
        search:'输入用户名、邮箱搜索',
        userBatchSet:'账户批量设置',
        spaceErr:'空间大小请输入正整数',
        deleteUserConfirm:'您确定要删除选中的用户吗？',
        deleteUserConfirm2: '当前用户个人空间没有与他人共享的文件夹',
        deleteUserConfirm3: '删除用户会删除其个人空间数据，并取消所有权限',
        deleteUserOdc:'该用户为离线文档管控中{0}目录的唯一链接审批者，删除后，该目录的链接审批规则将采用默认审批者逻辑。',
        deleteUserOdcMore:'该用户为离线文档管控中{0}等目录的唯一链接审批者，删除后，该目录的链接审批规则将采用默认审批者逻辑。',
        deleteUserApproval:'该用户为{0}目录审批规则的唯一审批者，删除后，该审批规则将采用默认审批者逻辑。',
        deleteUserApprovalMore:'该用户为{0}等目录审批规则的唯一审批者，删除后，该审批规则将采用默认审批者逻辑。',
        frozeUserOdc:'该用户为离线文档管控中{0}目录的唯一链接审批者，冻结后，该目录的链接审批规则将采用默认审批者逻辑。',
        frozeUserOdcMore:'该用户为离线文档管控中{0}等目录的唯一链接审批者，冻结后，该目录的链接审批规则将采用默认审批者逻辑。',
        frozeUserApproval:'该用户为{0}目录审批规则的唯一审批者，冻结后，该审批规则将采用默认审批者逻辑。',
        frozeUserApprovalMore:'该用户为{0}等目录审批规则的唯一审批者，冻结后，该审批规则将采用默认审批者逻辑。',
        confirm:'确认',
        confirmDelete:'确定删除',
        spaceNullErr:'空间大小不能为空',
        addOrg:'添加组织',
        searchOrg:'搜索组织名称',
        dissOrg:'解散组织',
        deleteOrg:'删除组织',
        renameOrg:'重命名组织',
        level:'所属层级',
        orgName:'组织名称',
        orgNamePlaceholder:'请输入组织名称，不超过128个字',
        dissOrgMsg:'您即将解散该组织及其子组织',
        dissOrgMsg2:'该组织下的成员及子组织将自动归属到上一级组织',
        deleteOrgMsg:'您确定要删除组织吗？',
        deleteOrgMsg2:'子组织和用户将一并删除',
        searchOrgNull:'没有搜到相关组织',
        selected:'已选中',
        members: '个成员',
        username: '用户名',
        email: '邮箱',
        mobile: '手机号',
        dcId:'数据中心',
        quota:'个人空间',
        ctime: '创建时间',
        teamName:'所属组织',
        etime: '到期时间',
        login_time:'最近登录时间',
        exporting:'导出中',
        cancel:'取消',
        all: '全部',
        inDay: '{0}天内',
        inDayOne: '{0}天内',
        userState:'账户状态',
        opearte:'操作',
        operationSet:'用户设置',
        operationMore: '更多',
        modifyEmail:'修改账户邮箱',
        deleteUser:'删除用户',
        orgNullUser:'当前组织下没有成员',
        choiceNullUser:'没有相关用户',
        loginEmial:'登录邮箱',
        normal:'正常',
        frozen:'已冻结',
        unfrozen:'未冻结',
        activeted:'已激活',
        unactiveted:'未激活',
        emialChange:'邮箱修改为',
        deleteSuccess:'删除成功',
        errorTextMax:'已达到可输入字符上限',
        forzeConfirm:'冻结账户操作会使该账户无法登陆网盘，但其个人空间中的数据和团队权限仍然保留。您确定要冻结该账户吗？',
        unforzeConfirm:'确认要解除冻结选中的用户吗？',
        forzeApproval:'您确定要冻结该账户吗？',
        forzeSuccess:'解除冻结成功',
        personNum: '人',
        searchRolePlacehodler: '输入要搜索的关键字',
        orgDeleteSuccess: '组织删除成功',
        export: '导出用户',
        customDialogHeader: '自定义列表项',
        enterpriseCertifiedUsers:'企业认证用户',
        thirdPartyCertifiedUsers:'第三方认证用户',
        exportOutTime:'导出超时，请重试。',
        save:'确认',
    },
    adminList: {
        title: '管理员设置',
        singleDelete: '确定要删除该管理员吗？',
        multipleDelete: '确定要删除选中的管理员吗？',
        addAdmin: '添加管理员',
        editAdmin: '编辑管理员',
        adminAuth: '管理权限',
        authScope: '管控范围',
        adminEmpty: '还没有管理员',
        userName: '用户名称：',
        auth: '管理权限：',
        scope: '管控范围：',
        posTeam: '指定团队',
        allTeam: '全部团队',
        posFile: '部分团队文件',
        allFile: '全部文件',
        searchTeam: '搜索团队名称',
        noSearchTeam: '没有搜索到相关团队',
        control: '已管控{0}个团队',
        addControl: '添加管控',
        nullControl: '还未添加管控团队',
        selectUser: '请选择一名用户',
        noSelectAuth: '还没有选择权限',
        noSelectTeam: '还没有选择管控团队',
        noAddTeam: '还没有添加管控的团队',
        addAdminOk: '添加管理员成功',
        chooseSame: '不能重复选择同一个团队',
        beyondlimit: '添加失败，管控团队数量超出上限',
        selectAuthTip: '请点击选择权限',
        repeatAuth: '不能重复赋予同一权限',
        inputUser: '请输入用户名或邮箱',
        nullUser: '没有搜索到相关用户名称',
        selectedTeam: '已选择{0}个团队',
        selectJoin: '请选择团队加入',
        searchNull: '没有搜索到相关用户',
        partFail: '部分删除失败，请在列表中查看后重试',
        controlNum: '共{0}个管控团队',
        controlTeamList: '团队管控列表',
        controlledTeams: '管控的{0}个团队：',
    },
    transferAuth: {
        title: '移交权限',
        searchTitle: '网盘成员',
        folderAuth: '文件夹共享成员',
        noAuth: '暂无共享成员',
        folders:'的{0}个共享文件夹',
        userTooltip:'所有用户中有人拥有与他人共享的文件夹，您可以：',
        userTooltip2:'1.彻底删除，清楚其个人文件夹和共享文件夹数据',
        userTooltip3:'2.将其共享文件夹移交给网盘其他用户',
        userTooltip4:'有{0}个人存在与他人共享文件夹',
        transfer: '移交并删除',
        tips: '选择的用户{0}拥有与他人共享的文件夹',
        tipsOrg: '组织中存在{0}拥有与他人共享的文件夹',
        tips2:'删除用户会删除其个人空间数据，并取消所有权限',
        tips3:'您可以：',
        tips4:'彻底删除用户将一并删除共享文件夹',
        tips5:'您可以在删除用户同时，将共享文件夹移交给其他用户',
        tips6:'请选择移交的共享文件夹，没有选择的共享文件夹将被彻底删除',
        selectUser:'已选中{0}个成员',
        deleted:'已删除',
        transferDeleted:'已移交并删除',
        delete:'彻底删除',
        searchResult:'搜索结果：',
        folderUser:'文件夹共享成员',
        userNull:'没有搜到相关成员',
        userSuccessTip:'用户权限移交并删除成功',
        userAllSuccess:'全部操作成功',
        userUserSuccess:'用户删除成功',
        userOtherSuccess: '部分操作已生效',
    },
    synctask:{
        title:'同步任务',
        tips:'将指定文件夹的文件，同步至其他数据中心，实现数据的归档',
        openservice: '联系客服开通服务，请拨打400-898-7968',
        choosefile: '请选择文件夹',
        addtasktips: '您目前最多可添加{0}个同步任务',
        addtasktipshover: '每部署一个同步模块，可添加{0}个同步任务',
        addtask: '添加同步任务',
        taskFolder: '同步文件夹',
        dataCenter: '所在数据中心',
        taskTo: '同步至',
        chooseDataCenter: '请选择数据中心',
        syncTiming: '定时同步',
        chooseTime: '选择时间点',
        folder: '文件夹',
        syncDataCenter: '同步数据中心',
        createTime: '创建时间',
        creater: '创建者',
        taskState: '任务状态',
        operate: '操作',
        notTask: '还没有同步任务',
        editTask: '修改同步任务',
        syncFolder: '同步文件夹',
        deleteTask:'删除同步任务',
        confimTask: '确认删除这条同步任务吗?',
        taskLog: '任务日志',
        change: '更改',
        exception: '异常',
        normal: '正常',
        taskSuccess: '同步任务创建成功',
        taskChangeSuccess: '修改成功',
        notSameTime: '不能选择同一时间',
        noModules: '未检测到同步模块，请先部署同步模块再添加任务',
    },
    app: {
        'thirdApp': '第三方应用',
        'appManager': '应用管理',
        'createApp': '创建应用',
        'editApp': '修改应用',
        'appName': '应用名称',
        'appDesc': '应用描述',
        'appIcon': '应用图标',
        'ipManage': 'IP管理',
        'addIp': '添加IP访问',
        'appNameTip': '请输入应用名称，不超过50个字符',
        'addIpDesc': '填写访问此应用的IP，多个IP请以“，”隔开，支持填写IP段，IP起始地址与终止地址使用“-”隔开',
        'rateLimit': '接口频率限制',
        'setRateLimit': '设置接口频率',
        'rateLimitDesc': '为防止应用程序频繁调用而引发服务器负载异常，默认情况下，每个服务端接口调用都有频率限制，当超过此限制时，调用对应接口时会返回对应错误码。',
        'rateLimitNumber': '需要提示上限数字',
        'rateLimitUnit': '次/分钟',
        'appVoucher': '应用凭证',
        'baseInfo': '基础信息',
        'appAvatar': '应用图标',
        'editInfo': '编辑信息',
        'backUp': '返回应用管理',
        'deleteApp': '删除应用',
        'voucher': '凭证与基础信息',
        'authManage': '权限管理',
        'createSuccess': '创建成功',
        'createError': '创建失败',
        'modifySuccess': '修改成功',
        'modifyError': '修改失败',
        'delSuccess': '删除成功',
        'delError': '删除失败',
        'modifyAuthSuccess': '批量设置成功',
        'modifyAuthError': '批量设置失败',
        'deleteConfirm': '删除确认',
        'appNumLimit': '应用数量达到上限，无法继续创建',
        'ipFormatError': 'IP范围格式错误',
        'deleteConfirmTitle': '您确定要删除该应用吗？',
        'deleteDesc': '请检查应用信息，删除后不可恢复，凭证将失效',
        'imgFormatLimit': '仅支持上传JPG/PNG格式',
        'imgBulkLimit': '图片必须小于120KB',
        'imgSizeLimit': '图片必须为240*240px以上',
        'imgTip': '请上传JPG/PNG格式、240*240px以上、1:1 、120kb以内的无圆角图标',
        'appNameRequired': '应用名称不能为空',
        'appNameIsExit': '应用名称已被占用',
        'ipRequired': '请添加访问IP',
        'nodesc': '暂未添加任何描述',
        'appDescTip': '请输入应用描述，不超过200个字符',
        'appVoucherDesc': '应用凭证包含Appkey和AppSecret两个字段，该字段是调用API时需要传递的凭证信息，使用者应该妥善保存。',
        'baseInfoDesc': '基础信息包含了应用名称和应用描述等信息，使用者可以按需修改此信息。',
        'ipDesc': '为防止任意IP连接应用，需要添加访问应用的IP才可使用，不在添加范围内的IP则无法连接应用。',
        'authDesc': '通过权限管理可以管控应用程序可调用的接口能力，选中的权限为可调用接口。',
        'rateDesc': '为防止应用程序频繁调用而引发服务器负载异常，默认情况下，每个服务端接口调用都有频率限制，当超过此限制时，调用对应接口时会返回对应错误码。',
        'rateCount': '每个接口一分钟内最大请求次数，最大可设置{0}次/分钟',
        'rateLimitTip': '超过上限{0}',
        'intSpace': '请输入正整数',
        'rateRequired': '应用频率限制不能为空',
        'ratePlaceholder': '请输入内容'
    },
    document: {
        header: {
            title: '开放对接平台',
            api: '服务端API',
            login: '登录',
        },
        Summary: '概述',
        ProductGuide: '产品指南',
        IntroductionToTerms: '名词介绍',
        usageMethod: '使用方法',
        getToken: '获取Token',
        useToken: '使用Token',
        GlobalReturnCode: '全局返回码',
        updateTime: '更新时间',
        UpdateTimeValue: '2021年2月26日',
        InterfaceDesc: '接口说明',
        baseInfo: '基本信息',
        requestType: '请求方式',
        requestAddress: '请求地址',
        requestParam: '请求参数',
        param: '参数',
        type: '类型',
        required: '必须',
        place: '位置',
        desc: '描述',
        default: '默认值',
        requestExamples: '请求示例',
        responseParam: '返回参数',
        responseExample: '返回示例',
        yes: '是',
        no: '否',
        api_file_list:'获取文件列表',
        api_file_list_desc:'通过此接口可以获取文件列表',
        api_file_info:'查询文件信息',
        api_file_info_desc:'获取指定路径的文件信息',
        api_file_info_byId:'通过id获取文件信息',
	    api_file_info_byId_desc:'获取指定Id的文件信息',
        api_file_content:'上传文件',
        api_file_content_desc:'通过此接口可以上传文件',
        api_file_need_upload_chunks:'获取需上传文件的块Hash列表',
        api_file_need_upload_chunks_desc:'有些数据块可能在网盘中已经存在，那么这些数据块在本次传输中就无需再次传递。  所以文件分块应该将数据块和该块的SHA-256值的对应关系记录下来，然后调用此接口以获取本次传输需要传递的数据块有哪些。Hash在此处特指SHA-256算法。',
        api_file_chunks_desc:'为了防止连接意外中断和提供断点续传功能，大文件需要将文件分成若干个小块上传。一“块”文件大小是4MB。将大文件分块时，应该从头开始，每4MB数据记录为一个文件块，并计算每一块数据的SHA-256值作为Hash。最后一块如果不足4MB也不需要填充。分块完成后，应该依次调用后续的三个接口。',
        Authorization_field_desc:'格式为bearer [token]',
        Authorization_field_desc_2: '格式为bearer [token] 使用具有网盘管理员的用户身份申请的token才能调用此接口。或者，不具备管理员权限的用户也可以输入自己的uid调用。',
        Authorization_field_desc_3: '格式为bearer [token] 使用具有网盘管理员的用户身份申请的token才能调用此接口。',
        ContentType_field_desc:'必须为application/x-www-form-urlencoded',
        path_type_field_desc:'路径类型: ent:企业空间,self:个人空间',
        sort_field_desc:'排序方式:asc 正序, desc 倒序',
        order_by_field__desc:'排序条件: name:文件名称,size:大小,mtime:更新时间 ',
        page_num_field_desc:'页码（不可为负数）',
        page_size_field_desc:'每页数量，取值范围（0，999）',
        errcode_field_desc:'错误码，成功：0',
        errmsg_field_desc:'错误描述，成功：ok',
        total_field_desc:'文件数量',
        desc_field_desc:'文件备注',
        dir_field_desc:'是否为文件夹',
        modified_field_desc:'最后修改时间',
        neid_field_desc:'文件id',
        nsid_field_desc:'命名空间id',
        path_field_desc:'上传路径（全路径，如：/a/b/test.txt）',
        pathType_field_desc:'路径类型: ent 企业空间，self 个人空间',
        rev_field_desc:'文件版本',
        size_field_desc:'文件大小',
        creator_field_desc:'创建者',
        creatorUid_field_desc:'创建者id',
        updator_field_desc:'更新者',
        updatorUid_field_desc:'更新者id',
        filedata_field_desc:'文件本体',
        chunk_hashes_field_desc:'块hash列表，如：["b2f09e4c62a6e43a2d445759d5f4cf6b16886d9dba68d1be43abd6127aeb96d1","d8bf7676c69f0c96d5e15469c70b16bbf696f086705060088d138496f7450a51"]',
        neededBlock_field_desc:'需要上传的文件块的SHA-256值。',
        uploadId_field_desc:'上传标记id，相当于文件的“预标识”，在后续上传文件块的操作中会需要用到。',
        api_file_chunk_uploadchunk_name: '上传文件块',
        api_file_chunk_uploadchunk_desc: '该接口用于上传数据块。上传数据块需提供数据块SHA-256值，数据块本体和之前获取的uploadId。',
        api_authorization: '格式为bearer [token]',
        api_contenttype_multipart: '必须为multipart/form-data',
        api_file_req_chunkhash: '文件块SHA-256值',
        api_file_req_uploadid: '上传Id,由获取需上传文件的块列表接口返回',
        api_file_req_filedata: '块文件本体',
        api_errorcode: '错误码，成功：0',
        api_errmsg: '错误描述，成功：ok',
        api_file_req_path: '路径',
        api_file_req_pathtype: '路径类型:ent:企业空间,self:个人空间',
        api_file_res_hash: '本次上传的文件块的hash',
        api_file_res_uploadId: '上传标记id',
        api_file_res_status: '状态',
        api_file_chunk_commitchunkupload_name: '提交文件上传',
        api_file_chunk_commitchunkupload_desc: '该接口用于结束整个分块上传流程。在调用该接口前，请确保所有数据块都已经上传完毕。调用接口需要提供总文件大小，对应数据块的SHA-256值列表，文件放入网盘的路径以及路径类型。',
        api_authorization: '格式为bearer [token]',
        api_contenttype_form: '必须为application/x-www-form-urlencoded',
        api_file_req_bytes: '文件大小',
        api_file_req_chunkhashes: '文件块hash列表',
        api_file_req_path: '路径',
        api_file_req_pathtype: '路径类型:ent:企业空间,self:个人空间',
        api_errorcode: '错误码，成功：0',
        api_errmsg: '错误描述，成功：ok',
        api_file_res_metadata: '上传文件的元数据信息，结构为文件模型',
        api_file_res_uploadId: '上传标记id',
        api_file_res_neededBlock: '需要上传的块',
        api_file_chunk_commitchunkupload_file_name: '文件模型（File）的结构如下：',
        api_file_res_desc: '描述',
        api_file_res_dirType: '是否文件夹',
        api_file_res_modified: '修改时间',
        api_file_res_neid: '文件id',
        api_file_res_path: '路径',
        api_file_res_pathType: '路径类型',
        api_file_res_rev: '版本号',
        api_file_res_size: '文件大小',
        api_file_fileopsauth_name: '获取数据中心地址',
        api_file_fileopsauth_desc: '该接口用于获取数据中心地址',
        api_authorization: '格式为bearer [token]',
        api_contenttype_form: '必须为application/x-www-form-urlencoded',
        api_file_req_path: '路径',
        api_file_req_pathtype: '路径类型:ent:企业空间,self:个人空间',
        api_errorcode: '错误码，成功：0',
        api_errmsg: '错误描述，成功：ok',
        api_file_res_region: '数据中心地址',
        api_file_res_session: 'sessionid',
        api_box_sessionid: 'Sessionid',
        api_contenttype_multipart: '必须为multipart/form-data',
        api_file_req_uploadpath: '上传路径（全路径，如：/a/b/test.txt）',
        api_file_req_overwrite: '是否覆盖原文件',
        api_file_req_language: '语言',
        api_file_req_source: '来源',
        api_file_req_pathtype: '路径类型:{ent:企业空间,self:个人空间}',
        api_file_req_file: '文件本体',
        api_file_res_result: '上传结果',
        api_file_res_uploadpath: '上传文件全路径',
        api_file_res_isdir: '是否是文件夹',
        api_file_res_owneruid: '归属者用户id',
        api_file_res_modified: '上传时间',
        api_file_res_creatoruid: '创建者用户id',
        api_file_res_neid: '文件id',
        api_file_res_rev: '版本号',
        api_file_res_regionid: '数据中心id',
        api_file_res_pathtype: '路径类型',
        api_file_res_size: '文件大小',
        api_file_res_updatoruid: '更新者用户id',
        api_file_res_mimetype: '文件类型',
        api_file_res_bytes: '字节数',
        api_file_res_hash: '文件hash值',
        api_file_res_desc: '描述',
        api_file_chunked_byopsauth_desc: '先调用获取数据中心地址接口获取数据中心地址，再依次调用以下接口，需要用获取数据中心地址接口返回的服务器地址作为上传域名。',
        api_file_chunked_checkblockbyopsauth_name: '判断文件块',
        api_file_chunked_checkblockbyopsauth_desc: '本接口判断用户所上传的文件块是否存在，返回需上传的文件块Hash信息。',
        api_box_sessionid: 'Sessionid',
        api_contenttype_form: '必须为application/x-www-form-urlencoded',
        api_file_req_uploadpath: '上传路径（全路径，如：/a/b/test.txt）',
        api_file_req_pathtype: '路径类型:{ent:企业空间,self:个人空间}',
        api_file_name: '文件名（例如:a.txt）',
        api_file_req_bytes: '文件大小',
        api_file_req_hashes: '块hash列表',
        api_file_res_chunkedneededblock: '需要上传的文件块的SHA-256值。',
        api_file_res_chunkeduploadid: '上传标记id，相当于文件的“预标识”，在后续上传文件块的操作中会需要用到。',
        api_file_chunked_uploadbyopsauth_name: '上传文件块',
        api_file_chunked_uploadbyopsauth_desc: '此接口用于上传数据块',
        api_box_sessionid: 'Sessionid',
        api_contenttype_multipart: '必须为multipart/form-data',
        api_file_req_chunkedhash: '文件块SHA-256值',
        api_file_req_chunkeduploadid: '上传Id,由获取需上传文件的块列表接口返回',
        api_file_req_chunkedoffset: '上传hash块的偏移量',
        api_file_res_chunkedhash: '本次上传的文件块的hash',
        api_file_res_chunkedstatus: '状态',
        api_file_chunk_commitchunkupload_name:'提交文件上传',
        api_file_chunk_commitchunkupload_desc:'提交文件上传',
        api_box_sessionid:'Sessionid',
        api_file_req_filepath:'上传路径',
        api_file_req_overwrite:'是否覆盖',
        api_file_req_isfilecommit:'是否文件提交',
        api_file_req_bytes:'整个文件大小',
        api_file_req_hashes:'文件块hash列表',
        api_file_req_path:'文件路径',
        api_file_req_range: '支持byRange下载 格式：bytes=0-4194304 bytes=4194304',
        api_file_req_pathtype:'目录路径类型:ent:企业空间,self:个人空间',
        api_file_create_folder_name:'创建文件夹',
        api_file_create_folder_desc:'创建文件夹',
        api_file_req_fromneid:'文件id',
        api_file_req_topath:'复制的目标路径',
        api_file_req_topathtype:'复制的目录路径类型:ent:企业空间,self:个人空间',
        api_errorcode:'错误码，成功：0',
        api_errmsg:'错误描述，成功：ok',
        api_file_create_folder_name:'创建文件夹',
        api_file_create_folder_desc:'创建文件夹',
        api_box_sessionid:'',
        api_file_req_path1:'要查询的路径',
        api_file_req_pathtype:'路径类型: ent:企业空间,self:个人空间',
        api_file_req_rev:'文件版本，不填则是最新版本',
        api_errorcode:'错误码，成功：0',
        api_errmsg:'错误描述，成功：ok',
        api_file_res_desc:'文件备注',
        api_file_res_modified:'最后修改时间',
        api_file_res_neid:'文件id',
        api_file_res_path:'文件路径',
        api_file_res_pathtype:'路径类型: ent 企业空间，self 个人空间',
        api_file_res_rev:'文件版本',
        api_file_res_size:'文件大小',
        api_file_res_creator:'创建者',
        api_file_res_creatorUid:'创建者id',
        api_file_res_updator:'更新者',
        api_file_res_updatorUid:'更新者id',
        api_f_name:'创建文件夹',
        api_file_delete_desc:'创建文件夹',
        api_file_req_neid:'文件id',
        api_errorcode:'错误码，成功：0',
        api_errmsg:'错误描述，成功：ok',
        api_file_download_by_id_name:'下载文件(文件id)',
        api_file_download_by_id_desc:'通过id下载文件',
        api_file_req_range:'支持byRange下载',
        api_file_req_neid:'文件id',
        api_file_req_rev:'文件版本，不填则是最新版本',
        api_file_res_return_desc:'返回为文件流。',
        api_file_download_by_path_name:'下载文件(文件路径)',
        api_file_download_by_path_desc:'通过路径下载文件',
        api_file_req_range:'支持byRange下载，格式：bytes=0-4194304',
        api_file_req_path:'要查询的路径',
        api_file_req_pathtype:'路径类型: ent:企业空间,self:个人空间',
        api_file_req_rev:'文件版本，不填则是最新版本',
        api_file_res_return_desc:'返回为文件流。',
        api_file_copy_name: '复制文件',
        api_authorization: '格式为bearer [token]',
        api_contenttype_form: '必须为application/x-www-form-urlencoded',
        api_file_req_fromneid: '文件id',
        api_errorcode: '错误码，成功：0',
        api_errmsg: '错误描述，成功：ok',
        api_file_req_tofilename: '文件名称（需带有文件后缀类型，例如：新名称.txt）',
        api_file_req_rev: '文件版本，不填写默认最新版本',
        api_file_res_previewurl: '文件预览url',
        api_delivery_req_expiration: '过期值:{格式YYYY-MM-DD     -1:表示不过期/网盘管理控制台-安全策略-链接安全管控中链接最长有效期时间}',
        api_delivery_req_ischeckedwatermark: '是否开启水印',
        api_delivery_req_mode: '访问权限:{r:允许下载,w:允许上传,p:允许预览, 三种权限可以组合}',
        api_delivery_req_neid: '文件id',
        api_delivery_req_code: '外链code（更新外链时传入）',
        api_delivery_req_password: '访问外链需要的密码',
        api_delivery_req_isloginverify: '登录认证',
        api_delivery_req_issnapshot: '文件快照（创建文件夹外链不可传入该参数）',
        api_delivery_req_limiteddownload: '可下载次数（创建文件夹外链不可传入该参数）',
        api_delivery_res_accessmode: '权限',
        api_delivery_res_code: '长链码',
        api_delivery_res_counterdownload: '下载地址',
        api_delivery_res_counterpreview: '预览次数',
        api_delivery_res_counterupload: '上传次数',
        api_delivery_res_ctime: '创建时间',
        api_delivery_res_description: '外链描述',
        api_delivery_res_expiration: '过期时间',
        api_delivery_res_haspassword: '是否输入密码 Default: false',
        api_delivery_res_id: '主键',
        api_delivery_res_mimetype: '文件类型',
        api_delivery_res_mode: '权限列表',
        api_delivery_res_mtime: '修改时间',
        api_delivery_res_neid: 'neid',
        api_delivery_res_nsid: 'nsid',
        api_delivery_res_password: '密码',
        api_delivery_res_path: '外链路径',
        api_delivery_res_root: 'databox',
        api_delivery_res_type: '类型',
        api_delivery_res_url: '打开地址',
        api_user_create_name: '创建用户',
        api_user_create_desc: '通过此接口可以创建一个新的用户',
        api_contenttype_form: '必须为application/x-www-from-unlencoded',
        api_manager_authorization: '格式为bearer [token]使用具有网盘管理员的用户身份申请的token才能调用此接口',
        api_user_email: '邮箱',
        api_user_phone: '手机号',
        api_user_password: '密码',
        api_user_quota: '用户个人空间大小，单位Byte',
        api_user_status: '用户状态:{冻结:-1,激活1}',
        api_user_name: '用户姓名',
        api_user_slug: '登录名',
        api_errorcode: '错误码，成功:0',
        api_errmsg: '错误描述，成功:ok',
        api_user_id: '用户id。该项是用户身份的不可变标识，创建用户后应该妥善保存该字段用于后续的修改操作。',
        api_user_used: '用户已使用个人空间大小(单位:Bytes)',
        api_user_getlist_name: '获取用户列表',
        api_user_getlist_desc: '通过此接口可以分页获取用户列表信息',
        api_user_getlist_key: '查询条件。可为登录名，用户姓名或者邮箱片段。',
        api_user_getlist_num: '页码',
        api_user_getlist_size: '每页数量，取值范围（0，1000）',
        api_user_getlist_total: '结果数量',
        api_user_getlist_userList: '用户数组。',
        api_team_list_name: '获取团队列表',
        api_team_list_desc: '通过此接口可以获取团队列表信息',
        api_team_id: '团队Id',
        api_team_array: '团队数组',
        api_team_total: '结果数量',
        api_team_teamlist: '团队数组',
        api_team_description: '团队描述',
        api_team_memberlimit: '团队人数上限',
        api_team_path: '团队路径，如/aaa',
        api_team_quota: '团队空间大小，单位：Bytes',
        api_team_name: '团队名称',
        api_team_get_name: '获取团队信息',
        api_team_get_desc: '根据团队id获取团队信息。',
        api_team_update_name: '更新团队信息',
        api_team_update_desc: '根据团队id更新团队信息。',
        api_contenttype_form: '必须为application/x-www-form-urlencoded',
        api_team_delete_name: '删除团队',
        api_team_delete_desc: '根据id删除团队',
        api_team_delete_password: '当前用户身份密码。删除团队操作需要二次校验，需要输入密码。',
        api_user_info_name: "获取用户信息",
        api_user_info_desc: "根据用户id获取用户信息。",
        api_user_update_name: "更新用户信息",
        api_user_update_desc: "根据用户id更新用户信息。",
        api_user_batchfreeze_name: "批量冻结用户",
        api_user_batchfreeze_desc: "在一次接口调用中同时冻结一批用户。",
        api_user_batchactivate_name: "批量解冻用户",
        api_user_batchactivate_desc: "在一次接口调用中同时解冻一批用户。",
        api_user_teamcreate_name: "创建用户团队关系",
        api_user_teamcreate_desc: "",
        api_user_teamdelete_name: "删除用户团队关系",
        api_user_teamdelete_desc: "",
        api_authorization: "",
        api_manager_authorization: "",
        api_contenttype_form: "",
        api_contenttype_multipart: "",
        api_team_req_id: "团队id",
        api_user_req_id: "用户id",
        api_user_req_email: "邮箱",
        api_user_req_mobile: "手机号",
        api_user_req_password: "密码",
        api_user_req_quota: "用户个人空间大小，单位Bytes",
        api_user_req_username: "用户姓名",
        api_user_req_uids: "用户id列表，用逗号分隔多个id",
        api_errcode: "错误码，成功：0",
        api_errmsg: "错误描述，成功：ok",
        api_user_res_id: "用户id。该项是用户身份的不可变标识，创建用户后应该妥善保存该字段用于后续的修改操作。",
        api_user_res_email :"邮箱",
        api_user_res_mobile :"手机号",
        api_user_res_quota: "用户个人空间大小（单位：Bytes）",
        api_user_res_status: "用户状态：冻结-1、未激活0、已激活1、过期-2、已删除-3",
        api_user_res_used: "用户已使用个人空间大小（单位：Bytes）",
        api_user_res_username: "用户姓名",
        api_user_res_userslug: "登录名",
        api_user_res_batch_list: "批量操作结果数组",
        api_user_res_batch_list_desc: "单个批量操作模型（BatchUserOp）定义如下",
        api_user_res_batch_list_code: "状态码",
        api_user_res_batch_list_message: "结果信息",
        api_user_res_batch_list_status: "状态编码,200为成功。",
        api_user_res_batch_list_type: "类型",
        api_user_res_batch_list_uid: "用户id",
        api_user_res_createmember: "当前团队下的所有用户信息。",
        api_user_res_createmember_desc: "团队用户关系模型（TeamUser）结构如下：",
        api_user_res_createmember_ctime: "创建时间",
        api_user_res_createmember_fromdomainaccount: "是否为域用户",
        api_user_res_createmember_role: "角色",
        api_user_res_createmember_team: "团队名称（非全路径）",
        "api_user_info_name":"获取用户信息",
        "api_user_info_desc":"根据用户id获取用户信息。",
        "api_user_update_name":"更新用户信息",
        "api_user_update_desc":"根据用户id更新用户信息。",
        "api_user_batchfreeze_name":"批量冻结用户",
        "api_user_batchfreeze_desc":"在一次接口调用中同时冻结一批用户。",
        "api_user_batchactivate_name":"批量解冻用户",
        "api_user_batchactivate_desc":"在一次接口调用中同时解冻一批用户。",
        "api_user_teamcreate_name":"创建用户团队关系",
        "api_user_teamcreate_desc":"",
        "api_user_teamdelete_name":"删除用户团队关系",
        "api_user_teamdelete_desc":"",
        "api_authorization":"",
        "api_manager_authorization":"",
        "api_contenttype_form":"",
        "api_contenttype_multipart":"",
        "api_team_req_id":"团队id",
        "api_user_req_id":"用户id",
        "api_user_req_email":"邮箱",
        "api_user_req_mobile":"手机号",
        "api_user_req_password":"密码",
        "api_user_req_quota":"用户个人空间大小，单位Bytes",
        "api_user_req_username":"用户姓名",
        "api_user_req_uids":"用户id列表，用逗号分隔多个id",
        "api_errcode":"错误码，成功：0",
        "api_errmsg":"错误描述，成功：ok",
        "api_user_res_id":"用户id。该项是用户身份的不可变标识，创建用户后应该妥善保存该字段用于后续的修改操作。",
        "api_user_res_email":"邮箱",
        "api_user_res_mobile":"手机号",
        "api_user_res_quota":"用户个人空间大小（单位：Bytes）",
        "api_user_res_status":"用户状态：冻结-1、未激活0、已激活1、过期-2、已删除-3",
        "api_user_res_used":"用户已使用个人空间大小（单位：Bytes）",
        "api_user_res_username":"用户姓名",
        "api_user_res_userslug":"登录名",
        "api_user_res_batch_list":"批量操作结果数组。",
        "api_user_res_batch_list_desc":"单个批量操作模型（BatchUserOp）定义如下",
        "api_user_res_batch_list_code":"状态码",
        "api_user_res_batch_list_message":"结果信息",
        "api_user_res_batch_list_status":"状态编码,200为成功。",
        "api_user_res_batch_list_type":"类型",
        "api_user_res_batch_list_uid":"用户id",
        "api_user_res_createmember":"当前团队下的所有用户信息。",
        "api_user_res_createmember_desc":"团队用户关系模型（TeamUser）结构如下：",
        "api_user_res_createmember_ctime":"创建时间",
        "api_user_res_createmember_fromdomainaccount":"是否为域用户",
        "api_user_res_createmember_role":"角色",
        "api_user_res_createmember_team":"团队名称（非全路径）",
        "file": "文件",
        "GetFileList": "获取文件列表",
        "QueryFileInfor": "查询文件信息",
        "GetFlieInfpById": "通过id获取文件信息",
        "GetHistoryApi": "获取历史版本接口",
        "UpdateFile": "上传文件",
        "FileBlock": "文件分块",
        "GetHashforUpdateFile": "获取需上传文件的块Hash列表",
        "UpdateFileBlock": "上传文件块",
        "CommitFileUpdate": "提交文件上传",
        "GetDataCore": "获取数据中心地址",
        "Update(dataCore)": "上传文件(数据中心)",
        "FileBlock(dataCore)": "文件分块(数据中心)",
        "CheckFileBlock": "判断文件块",
        "UpdateDataBlock": "上传文件块",
        "CommitFile": "提交文件",
        "DownloadFileById": "下载文件(文件id)",
        "DownloadFileByPath": "下载文件(文件路径)",
        "CreateFolder": "创建文件夹",
        "DeleteFile": "删除文件",
        "CopyFile": "复制文件",
        "MoveFile": "移动文件",
        "RenameFile": "重命名文件",
        "GetPreviewAddress": "在线预览",
        "delivery": "外链",
        "CreateDelivery": "创建或更新外链",
        "DeleteDelivery": "删除外链",
        "GetDeliveryInfo": "获取外链信息",
        "GetDeliveryList": "获取外链列表",
        "team": "团队",
        "CreateTeam": "创建团队",
        "GetTeamList": "获取团队列表",
        "GetTeamInfo": "获取团队信息",
        "UpdateTeamInfo": "更新团队信息",
        "DeleteTeam": "删除团队",
        "user": "用户",
        "CreateUser": "创建用户",
        "GetUserList": "获取用户列表",
        "GetUserInfo": "获取用户信息",
        "UpdateUserInfo": "更新用户信息",
        "BatchFrozenUser": "批量冻结用户",
        "BatchUnfreezeUser": "批量解冻用户",
        "CreateTeamUserRelation": "创建团队用户关系",
        "DeleteTeamUserRelation": "删除团队用户关系",
        api_file_chunk_uploadchunk_name: '上传文件块',
        api_file_chunk_uploadchunk_desc: '该接口用于上传数据块。上传数据块需提供数据块SHA-256值，数据块本体和之前获取的uploadId。',
        api_authorization: '格式为bearer [token]',
        api_contenttype_multipart: '必须为multipart/form-data',
        api_file_req_chunkhash: '文件块SHA-256值',
        api_file_req_uploadid: '上传Id,由获取需上传文件的块列表接口返回',
        api_file_req_filedata: '块文件本体',
        api_errorcode: '错误码，成功：0',
        api_errmsg: '错误描述，成功：ok',
        api_file_req_path: '路径',
        api_file_req_pathtype: '路径类型:ent:企业空间,self:个人空间',
        api_file_res_hash: '本次上传的文件块的hash',
        api_file_res_uploadId: '上传标记id',
        api_file_res_status: '状态',
        api_file_chunk_commitchunkupload_name: '提交文件上传',
        api_file_chunk_commitchunkupload_desc: '该接口用于结束整个分块上传流程。在调用该接口前，请确保所有数据块都已经上传完毕。调用接口需要提供总文件大小，对应数据块的SHA-256值列表，文件放入网盘的路径以及路径类型。',
        api_authorization: '格式为bearer [token]',
        api_contenttype_form: '必须为application/x-www-form-urlencoded',
        api_file_req_bytes: '文件大小',
        api_file_req_chunkhashes: '文件块hash列表',
        api_file_req_path: '路径',
        api_file_req_pathtype: '路径类型:ent:企业空间,self:个人空间',
        api_errorcode: '错误码，成功：0',
        api_errmsg: '错误描述，成功：ok',
        api_file_res_metadata: '上传文件的元数据信息，结构为文件模型',
        api_file_res_uploadId: '上传标记id',
        api_file_res_neededBlock: '需要上传的块',
        api_file_chunk_commitchunkupload_file_name: '文件模型（File）的结构如下：',
        api_file_res_desc: '描述',
        api_file_res_dirType: '是否文件夹',
        api_file_res_modified: '修改时间',
        api_file_res_neid: '文件id',
        api_file_res_path: '路径',
        api_file_res_pathType: '路径类型',
        api_file_res_rev: '版本号',
        api_file_res_size: '文件大小',
        api_file_fileopsauth_desc: '判断是否能够上传，如果可以上传返回上传数据中心服务器地址。',
        api_authorization: '格式为bearer [token]',
        api_file_req_full_path: '上传路径（全路径，如：/a/b）',
        api_file_req_pathtype: '路径类型:ent:企业空间,self:个人空间',
        api_errorcode: '错误码，成功：0',
        api_errmsg: '错误描述，成功：ok',
        api_file_res_region: '数据中心地址',
        api_file_res_session: 'sessionid',
        api_file_uploadbyopsauth_name: '上传文件(数据中心)',
        api_file_uploadbyopsauth_desc: '先调用获取数据中心地址接口获取到上传地址和session后，再调用以下接口，需要用获取数据中心地址接口返回的服务器地址作为上传域名。',
        api_box_sessionid: 'Sessionid',
        api_contenttype_multipart: '必须为multipart/form-data',
        api_file_req_uploadpath: '上传路径（全路径，如：/a/b/test.txt）',
        api_file_req_overwrite: '是否覆盖原文件',
        api_file_req_language: '语言',
        api_file_req_source: '来源',
        api_file_req_pathtype: '路径类型:{ent:企业空间,self:个人空间}',
        api_file_req_file: '文件本体',
        api_file_res_result: '上传结果',
        api_file_res_uploadpath: '上传文件全路径',
        api_file_res_isdir: '是否是文件夹',
        api_file_res_owneruid: '归属者用户id',
        api_file_res_modified: '上传时间',
        api_file_res_creatoruid: '创建者用户id',
        api_file_res_neid: '文件id',
        api_file_res_rev: '版本号',
        api_file_res_regionid: '数据中心id',
        api_file_res_pathtype: '路径类型',
        api_file_res_size: '文件大小',
        api_file_res_updatoruid: '更新者用户id',
        api_file_res_mimetype: '文件类型',
        api_file_res_bytes: '字节数',
        api_file_res_hash: '文件hash值',
        api_file_res_desc: '描述',
        api_file_chunked_byopsauth_name: '文件分块(数据中心)',
        api_file_chunked_byopsauth_desc: '先调用获取数据中心地址接口获取数据中心地址，再依次调用以下接口，需要用获取数据中心地址接口返回的服务器地址作为上传域名。',
        api_file_chunked_checkblockbyopsauth_name: '判断文件块',
        api_box_sessionid: 'Sessionid',
        api_contenttype_form: '必须为application/x-www-form-urlencoded',
        api_file_req_uploadpath: '上传路径（全路径，如：/a/b/test.txt）',
        api_file_req_pathtype: '路径类型:{ent:企业空间,self:个人空间}',
        api_file_req_bytes: '文件大小',
        api_file_req_hashes: '块hash列表',
        api_file_res_chunkedneededblock: '需要上传的文件块的SHA-256值。',
        api_file_chunked_uploadbyopsauth_desc: '该接口用于上传文件块。上传数据块需提供文件块SHA-256值。',
        api_box_sessionid: 'Sessionid',
        api_contenttype_multipart: '必须为multipart/form-data',
        api_file_req_chunkedhash: '文件块SHA-256值',
        api_file_req_chunkeduploadid: '上传Id,由获取需上传文件的块列表接口返回',
        api_file_req_chunkedoffset: '上传hash块的偏移量',
        api_file_res_chunkedhash: '本次上传的文件块的hash',
        api_file_res_chunkedstatus: '状态',
        api_authorization:'格式为bearer [token]',
        api_contenttype_form:'必须为application/x-www-form-urlencoded',
        api_errorcode:'错误码，成功：0',
        api_errmsg:'错误描述，成功：ok',
        api_file_copy_name:'复制文件',
        api_file_copy_desc:'将文件复制到指定文件夹下。',
        api_file_req_fromneid:'文件id',
        api_file_req_tofilename:'文件名称（需带有文件后缀类型，例如：新名称.txt）',
        api_file_req_rev:'文件版本，不填写默认最新版本',
        api_file_res_previewurl:'文件预览url',
        api_file_move_name:'移动文件',
        api_file_move_desc:'将文件移动到指定文件夹下。',
        api_file_move_req_topath:'移动的目标路径',
        api_file_move_req_topathtype:'移动的目录路径类型:ent:企业空间,self:个人空间',
        api_file_rename_name:'重命名文件',
        api_file_rename_desc:'重命名文件',
        api_file_preview_name:'在线预览',
        api_file_preview_desc:'根据文件id和版本信息获取文件的预览地址。',
        api_delivery_create_name:'创建或更新外链',
        api_delivery_create_desc:'创建或更新外链，更新外链时需要传入外链code。',
        api_delivery_req_expiration:'过期值:{格式YYYY-MM-DD     -1:表示不过期/网盘管理控制台-安全策略-链接安全管控中链接最长有效期时间}',
        api_delivery_req_ischeckedwatermark:'是否开启水印',
        api_delivery_req_mode:'访问权限:{r:允许下载,w:允许上传,p:允许预览, 三种权限可以组合}',
        api_delivery_req_neid:'文件id',
        api_delivery_req_code:'外链code（更新外链时传入）',
        api_delivery_req_delete_code:'创建外链时返回的code字段',
        api_delivery_req_password:'访问外链需要的密码',
        api_delivery_req_isloginverify:'登录认证',
        api_delivery_req_issnapshot:'文件快照（创建文件夹外链不可传入该参数）',
        api_delivery_req_limiteddownload:'可下载次数（创建文件夹外链不可传入该参数）',
        api_delivery_res_accessmode:'权限',
        api_delivery_res_code:'长链码',
        api_delivery_res_counterdownload:'下载地址',
        api_delivery_res_counterpreview:'预览次数',
        api_delivery_res_counterupload:'上传次数',
        api_delivery_res_ctime:'创建时间',
        api_delivery_res_description:'外链描述',
        api_delivery_res_expiration:'过期时间',
        api_delivery_res_haspassword:'是否输入密码 Default : false',
        api_delivery_res_id:'主键',
        api_delivery_res_mimetype:'文件类型',
        api_delivery_res_mode:'权限列表',
        api_delivery_res_mtime:'修改时间',
        api_delivery_res_neid:'文件id',
        api_delivery_res_nsid:'命名空间id',
        api_delivery_res_password:'密码',
        api_delivery_res_path:'外链路径',
        api_delivery_res_root:'databox',
        api_delivery_res_type:'类型',
        api_delivery_res_url:'打开地址',
        api_delivery_delete_name:'删除外链',
        api_delivery_delete_desc:'根据外链code删除外链。',
        api_file_chunk_commitchunkupload_idt_name:'提交文件上传',
        api_file_chunk_commitchunkupload_idt_desc:'提交文件上传',
        api_box_sessionid:'Sessionid',
        api_file_req_filepath:'上传路径',
        api_file_req_overwrite:'是否覆盖',
        api_file_req_isfilecommit:'是否文件提交',
        api_file_req_bytes:'整个文件大小',
        api_file_req_hashes:'文件块hash列表',
        api_file_req_path:'文件路径',
        api_file_req_pathtype:'目录路径类型:ent:企业空间,self:个人空间',
        api_file_copy_name:'复制文件',
        api_file_req_fromneid:'文件id',
        api_file_req_to_movepath:'移动的目标路径',
        api_file_req_to_movepathtype:'移动的目录路径类型:ent:企业空间,self:个人空间',
        api_errorcode:'错误码，成功：0',
        api_errmsg:'错误描述，成功：ok',
        api_file_create_folder_name:'创建文件夹',
        api_file_create_folder_desc:'创建文件夹',
        api_file_req_path:'要查询的路径',
        api_file_req_pathtype:'路径类型: ent:企业空间,self:个人空间',
        api_file_res_desc:'文件备注',
        api_file_res_modified:'最后修改时间',
        api_file_res_neid:'文件id',
        api_file_res_path:'文件路径',
        api_file_res_pathtype:'路径类型: ent 企业空间，self 个人空间',
        api_file_res_rev:'文件版本',
        api_file_res_size:'文件大小',
        api_file_res_creator:'创建者',
        api_file_res_creatorUid:'创建者id',
        api_file_res_updator:'更新者',
        api_file_res_updatorUid:'更新者id',
        api_file_delete_name:'删除文件',
        api_file_delete_desc:'根据id删除文件',
        api_file_req_neid:'文件id',
        api_file_download_by_id_name:'下载文件(文件id)',
        api_file_download_by_id_desc:'通过id下载文件',
        api_file_req_range:'支持byRange下载',
        api_file_req_neid:'文件id',
        api_file_req_nsid:'命名空间id',
        api_file_req_rev:'文件版本，不填则是最新版本',
        api_file_res_return_desc:'返回为文件流。',
        api_file_download_by_path_name:'下载文件(文件路径)',
        api_file_download_by_path_desc:'通过路径下载文件',
        api_file_req_range:'支持byRange下载，格式：bytes=0-4194304',
        api_file_req_path:'全路径(例如： a/b/c)',
        api_fileopsauth_req_path: '上传路径 全路径(例如： a/b/c)',
        api_file_req_pathtype:'路径类型: ent:企业空间,self:个人空间',
        api_file_req_rev:'文件版本，不填则是最新版本',
        api_file_res_return_desc:'返回为文件流。',
        api_teamCreate_desc: '创建一个新团队',
        api_teamCreate_authorization: '格式为bearer [token]使用具有团队管理员的用户身份申请的token才能调用此接口',
        api_teamCreate_authorization_2: '格式为bearer [token]使用具有网盘管理员的用户身份申请的token才能调用此接口',
        api_teamCreate_contentType: '必须为application/x-www-form-urlencoded',
        api_teamCreate_description: '团队描述',
        api_teamCreate_member_limit: '团队人数上限（不控制子团队）',
        api_teamCreate_name: '团队名称，如/aaa',
        api_teamCreate_quota: '团队空间大小，单位Bytes（必须为1048576的倍数）',
        api_teamCreate_regin_id: '数据中心id',
        api_teamCreate_description_explain: '团队描述',
        api_teamCreate_id_explain: '团队id',
        api_teamCreate_member_limit_explain: '团队人数上限',
        api_teamCreate_path_explain: '团队路径，如/aaa',
        api_teamCreate_quota_explain: '团队空间大小，单位：Bytes',
        api_teamCreate_region_id_explain: '数据中心id',
        api_develiy_get_info: '获取外链信息',
        api_develiy_get_info_desc: '根据code获取外链信息',
        api_develiy_get_info_Authorization: '格式为bearer [token]',
        api_develiy_get_info_code: '外链码',
        api_develiy_get_info_accessMode: '权限',
        api_develiy_get_info_longCode: '长链码',
        api_develiy_get_info_counterDownload: '下载次数',
        api_develiy_get_info_counterPreview: '预览次数',
        api_develiy_get_info_counterUpload: '上传次数',
        api_develiy_get_info_ctime: '创建时间',
        api_develiy_get_info_description: '外链描述',
        api_develiy_get_info_expiration: '过期时间',
        api_develiy_get_info_hasPassword: '是否输入密码 default：false',
        api_develiy_get_info_id: '主键',
        api_develiy_get_info_mimeType: '文件类型',
        api_develiy_get_info_mode: '权限列表',
        api_develiy_get_info_mtime: '修改时间',
        api_develiy_get_info_password: '密码',
        api_develiy_get_info_path: '外链路径',
        api_develiy_get_info_type: '类型',
        api_develiy_get_info_url: '打开地址',
        api_token_field_desc: '格式为Basic base64([appKey]:[appSecret]),例如，对于appKey=aaa和appSecret=bbb，你需要先拼接出“aaa:bbb”，然后进行base64编码，最终的请求头为Authorization: Basic YWFhOmJiYg==',
        api_token_path_field_desc: '此处需填写固定值client_with_su',
        api_token_path_field_desc_scope: '应用能对用户做的操作范围。此处需填写固定值all',
        api_token_slug: '用户登录名。这表示生成token后能代表哪个用户调用API。',
        api_get_token_error: '获取token失败',
        api_token_error: 'token过期或者不存在',
        api_token_scope: '应用能对用户做的操作范围。与申请令牌时填写的一致。',
        api_token_token_type: '目前固定为bearer',
        api_token_access_token: '获取到的令牌',
        api_token_expires_in: '令牌的有效时间（秒）',
        api_token_cankao: '参考',
        api_token_yuanyin: '原因',
        api_token_chenggong:'请求成功',
        api_token_shibai:'参数错误',
        api_token_yichang:'鉴权异常',
        api_token_jinzhi:'操作被禁止',
        api_token_bucunzai:'请求的实体不存在',
        api_token_buyunxu:'不允许使用请求行中所指定的方法',
        api_token_chongtu:'请求的资源冲突',
        api_token_weimanzu:'请求的资源未满足前提条件',
        api_token_cuowu:'服务内部错误',
        api_token_fanhui: '返回字段',
        api_token_zhuyishixiang: '注意事项',
        api_token_zhuyishixiang_decs1: '开发者需要缓存access_token，用于后续接口的调用（注意：不能频繁调用此接口，否则会受到频率拦截）。当access_token失效或过期时，需要重新获取。',
        api_token_zhuyishixiang_decs2: 'access_token的有效期通过返回的expires_in来传达，同一应用在有效期内重复针对同一用户获取令牌将返回相同结果，过期后获取会返回新的access_token。',
        api_token_zhuyishixiang_decs3: '由于运营策略，不保证token在有效期内持续有效。开发者应实现access_token失效时重新获取的逻辑。',
        api_token_zhuyishixiang_decs4: 'access_token至少保留512字节的存储空间。',
        api_use_token_decs1: '获取到token后，就能使用开放平台提供的API了。在调用API时，只需要添加如下所示的Authorization请求头即可。',
        api_use_token_decs2: 'Authorization: bearer [token]',
        api_use_token_decs3: '请将[token]替换为之前已获取的token内容。',
        api_token_subtitle: '获取token是调用开放平台API接口的第一步，几乎所有的业务API接口都需要依赖于token来确定调用方（应用，app）和用户（user）身份。',
        api_chanpinzhinan_decs1: 'Filez开放对接平台是基于zBox基础业务和功能向企业提供二次开发的服务平台，为企业提供智能安全的多人文件编辑、协作与管理的解决方案。平台面向企业或第三方开发人员，通过开放接口与企业内部系统实现对接，满足企业个性化的文件管理需求。',
        api_chanpinzhinan_decs2: 'Filez提供了文件操作、链接管理、团队管理、用户管理四个部分的API，企业可以使用这些API，为企业的文件管理赋能助力。',
        api_mingcijieshao1: '1. 应用（app）',
        api_mingcijieshao_decs1: '一个应用（app）代表一个开放平台API的调用主体。目前开放平台API不提供匿名访问机制，因此需要持有应用身份信息（详细信息见令牌解释）才能使用开放平台提供的API。',
        api_mingcijieshao_decs2: '应用身份信息包含两个字段：',
        api_mingcijieshao_decs3: 'appKey，用于唯一确定一个应用的信息（相当于用户名）',
        api_mingcijieshao_decs4: 'appSecret，用于防止应用信息被冒用（相当于密码）',
        api_mingcijieshao_decs5: '这两个字段由开放平台提供，开放平台API的调用者应该妥善保存。为确保安全性，对于appSecret，应该只在后台调用时传递。',
        api_mingcijieshao2: '2. 用户（user）',
        api_mingcijieshao_decs7: '用户（user）在本文档若无特殊说明特指filez Box用户。',
        api_mingcijieshao3: '3. 令牌（token）',
        api_mingcijieshao_decs8: '令牌（token）是调用所有API都需要传递的凭证信息。若想调用API需要携带应用信息和用户信息到指定的端点申请令牌（详见后续部分）。这就意味着一个令牌对应一个应用信息和一个用户信息。若想使用若干不同用户的身份调用API，则需要针对每一个用户申请一次令牌。',
        api_mingcijieshao4: '4. 参数',
        api_mingcijieshao_decs9: '调用API需要传递参数。在后续章节中，我们使用方括号来代表需要传递的参数。如token=[token]，就代表需要将[token]替换为需要传递的参数。另外，有些参数需要用某些函数处理，处理函数我们使用斜体表示，如base64([token])，表示将token参数传递后，再做一次base64编码处理。',
        api_file_chunk_req_path: '路径',
        fileModelList_field_desc: '文件列表（见单个文件模型）',
        api_team_region_id: '数据中心id',
        api_file_req_path_2: '路径',
        api_file_req_path_3: '文件路径（全路径，如：/a/b/test.txt）',
    },
    // 安全连接翻译开始
    '安全链接': '安全链接',
    '链接安全管控': '链接安全管控',
    '管控目录的文件': '管控目录的文件',
    '如果允许管控目录内的文件移动或复制，会导致文件不受此规则管控': '如果允许管控目录内的文件移动或复制，会导致文件不受此规则管控',
    '禁止移动': '禁止移动',
    '禁止复制': '禁止复制',
    '链接最长有效期': '链接最长有效期',
    '目录所在路径': '目录所在路径',
    '禁止重命名': '禁止重命名',
    '联系客服开通服务，请拨打 400-898-7968': '联系客服开通服务，请拨打 400-898-7968',
    '如果管控目录所在路径被重命名，会导致此管控规则失效': '如果管控目录所在路径被重命名，会导致此管控规则失效',
    '目录链接管控规则': '目录链接管控规则',
    '规则说明': '规则说明',
    '添加管控规则': '添加管控规则',
    '管控白名单': '管控白名单',
    '天': '天',
    '年': '年',
    //sp2-start
    '禁止上传': '禁止上传',
    '禁止下载': '禁止下载',
    '禁止预览': '禁止预览',
    '仅内部成员可用': '仅内部成员可用',
    '最长有效期': '最长有效期',
    '请输入正整数': '请输入正整数',
    '生成链接必须添加密码': '生成链接必须添加密码',
    '最多阅读次数': '最多阅读次数',
    '最长阅读时长': '最长阅读时长',
    '文档只读': '文档只读',
    '禁止打印': '禁止打印',
    '失效后删除': '失效后删除',
    '添加水印': '添加水印',
    '请输入水印': '请输入水印',
    '取消': '取消',
    '确定': '确定' ,
    '提交': '提交',
    '暂无搜索结果': '暂无搜索结果',
    '子团队继承规则': '子团队继承规则',
    '最多可下载次数': '最多可下载次数',
    '还未配置规则': '还未配置规则',
    '您可以添加规则来限制网盘成员使用链接的设置项': '您可以添加规则来限制网盘成员使用链接的设置项',
    '没有相应的目录': '没有相应的目录',
    '白名单': '白名单',
    '管控目录': '管控目录',
    '管控用户': '管控用户',
    '创建者': '创建者',
    '审批者': '审批者',
    '创建时间': '创建时间',
    '操作': '操作',
    '设置': '设置',
    '删除': '删除',
    '返回链接管控设置': '返回链接管控设置',
    '目录链接规则设置': '目录链接规则设置',
    '点击或搜索目录名': '点击或搜索目录名',
    '企业空间': '企业空间',
    '设置普通链接管控': '设置普通链接管控',
    '设置安全链接管控': '设置安全链接管控',
    '次': '次',
    '小时': '小时',
    '所有用户': '所有用户',
    '删除成功': '删除成功',
    '删除失败': '删除失败',
    '管控规则已达上限': '管控规则已达上限',
    '提交成功': '提交成功',
    '提交失败': '提交失败',
    '网络问题，请重新尝试提交': '网络问题，请重新尝试提交',
    '请输入': '请输入',
    '水印': '水印',
    '请选择要管控的目录': '请选择要管控的目录',
    '请选择受管控的用户': '请选择受管控的用户',
    '请至少允许一项': '请至少允许一项',
    '始终链接到文件最新版本': '始终链接到文件最新版本',
    '提示': '提示',
    '链接安全管控规则不会影响历史创建的安全链接，请检查历史链接是否存在安全风险！是否确认提交？': '链接安全管控规则不会影响历史创建的安全链接，请检查历史链接是否存在安全风险！是否确认提交？',
    '您确认要删除选中的管控规则吗？': '您确认要删除选中的管控规则吗？',
    '全局规则获取失败': '全局规则获取失败',
    '输入用户名或邮箱，添加白名单用户': '输入用户名或邮箱，添加白名单用户',
    '白名单仅可以添加用户，被添加到白名单的用户不受到管控规则的影响。': '白名单仅可以添加用户，被添加到白名单的用户不受到管控规则的影响。',
    //sp2-end
    // 安全连接翻译结束
    //hover优化start
    '路径：': '路径：',
    '邮箱：':'邮箱：',
    //hover优化end

    //文件夹加密start
    '名称': '名称',
    '邮箱':'邮箱',
    '路径': '路径',
    '还未添加管控成员':'还未添加管控成员',
    '管控成员设置成功':'管控成员设置成功',
    '管控规则设置成功':'管控规则设置成功',
    '添加白名单':'添加白名单',
    '搜索目录：':'搜索目录：',
    '搜索用户：':'搜索用户：',
    '管控规则：':'管控规则：',
    '添加管控白名单':'添加管控白名单',
    '所属团队':'所属团队',
    '请输入管控目录内的文件夹名称':'请输入管控目录内的文件夹名称',
    '添加管控规则白名单：':'添加管控规则白名单：',
    '受管控成员白名单：':'受管控成员白名单：',
    '添加受控成员白名单':'添加受控成员白名单',
    '管控目录白名单：':'管控目录白名单：',
    '添加白名单目录':'添加白名单目录',
    '还没有添加白名单目录':'还没有添加白名单目录',
    '还没有添加白名单':'还没有添加白名单',
    '请选择一个管控目录':'请选择一个管控目录',
    '请添加受管控成员':'请添加受管控成员',
    '当前配置与历史配置规则冲突，重复配置将覆盖之前记录，是否需要覆盖？':'当前配置与历史配置规则冲突，重复配置将覆盖之前记录，是否需要覆盖？',
    '您的企业暂未开通此服务，如需开通功能请拨打客服电话：400-898-7968':'您的企业暂未开通此服务，如需开通功能请拨打客服电话：400-898-7968',
    '设置离线文档管控，会对下载到本地的敏感文档有更安全的保护':'设置离线文档管控，会对下载到本地的敏感文档有更安全的保护',
    '白名单设置成功':'白名单设置成功',
    '路径不存在':'路径不存在',
    '已选择该目录':'已选择该目录',
    '可添加管控目录下的子目录不受管控规则限制':'可添加管控目录下的子目录不受管控规则限制',
    '添加失败，团队、组织或成员超出100条上限':'添加失败，团队、组织或成员超出100条上限',
    '添加失败，团队或成员超出100条上限':'添加失败，团队或成员超出100条上限',
    '已选择该用户':'已选择该用户',
    '选择的用户为白名单中的用户，管控将不会对此用户生效':'选择的用户为白名单中的用户，管控将不会对此用户生效',
    '选择的用户中存在白名单用户，管控将不会对此类用户生效':'选择的用户中存在白名单用户，管控将不会对此类用户生效',
    //文件夹加密end
    '管理员':'管理员',
    '团队管理员': '团队管理员',
    '最多能设置5个审批者':'最多能设置5个审批者',
    '没有相应的成员':'没有相应的成员',
    '共{0}项':'共{0}项',
    '添加审批规则白名单':'添加审批规则白名单',
};
module.exports = a





// WEBPACK FOOTER //
// ./static/js/language/zh.js